// extracted by mini-css-extract-plugin
export default {"cardHoldContainer":"CardHold_cardHoldContainer__mYXyK","sectionTitle":"CardHold_sectionTitle__MDs6-","placeHoldBtn":"CardHold_placeHoldBtn__Ed+x2"};